<template>
  <div>
    <div class="row">
      <div class="col-11">
        <SectionTitle
          icon="fas fa-info-circle"
          content="Transportación"
          container-class="tag-badge mt-5 mb-4"
        />
      </div>
      <div v-if="canDelete && !disabled" class="col-1 d-flex justify-content-end align-items-center">
        <action-button
          i="far fa-times pointer icon-right color-primary-3 font-28"
          class="px-1 mr-2 "
          @click="$emit('delete')"
        />
      </div>
    </div>

    <div class="d-flex flex-column">
      <div class="question-element">
        <div class="item-pane color-secondary-6">
          <div class="question-line col py-3 p-0">
            <b class="mb-0">
              El estudiante presenta una discapacidad significativa.
            </b>
          </div>
          <div class="align-items-end d-flex p-0 custom-radio-container">
            <validation-provider
              immediate
              v-slot="{ errors }"
              :rules="validable ? 'required' : ''"
            >
              <custom-radio
                label=""
                is-question-list
                id="hasSignificantDisability"
                name="hasSignificantDisability"
                class="radio-button-container"
                v-model="model.hasSignificantDisability"
                :change-event="updateSignificantDisability"
                :options="significantDisabilityOptions"
                custom-error-msg="Favor de seleccionar Si o No."
                :error="Boolean(errors[0])"
                :disabled="disabled"
              />
            </validation-provider>
          </div>
        </div>
      </div>

      <div class="question-element">
        <div class="item-pane color-secondary-6">
          <div class="question-line col py-3 p-0">
            <b class="mb-0">
              La discapacidad del estudiante no le permite viajar sin la supervisión de un adulto, adicional al chofer, aun cuando se utilice medidas de seguridad como los cinturones o asientos especiales, sin que esto represente un riesgo real a su seguridad o a la de otros estudiantes que le acompañan.
            </b>
          </div>
          <div class="align-items-end d-flex p-0 custom-radio-container">
            <validation-provider
              immediate
              v-slot="{ errors }"
              :rules="validable? 'required' : ''"
            >
              <custom-radio
                label=""
                is-question-list
                id="travelUnsupervisedRequired"
                name="travelUnsupervisedRequired"
                class="radio-button-container"
                v-model="model.travelUnsupervisedRequired"
                :change-event="updateTravelUnsupervisedSelection"
                :options="travelUnsupervisedOptions"
                custom-error-msg="Favor de seleccionar Si o No."
                :error="Boolean(errors[0])"
                :disabled="disabled"
              />
            </validation-provider>
          </div>
        </div>
      </div>

      <div class="mt-4 pb-4 pr-2">
        <div>Comentarios Adicionales:</div>
        <CustomTextArea
          id="commentarycomments"
          v-model="model.comment"
          class="mt-2"
          :placeholder="'Escriba un comentario'"
          :maxlength="3000"
          show-char-count
          :count-classes="['d-block text-right']"
          :rows="5"
          :disabled="disabled"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { SectionTitle } from "@/components/pei/shared";
import CustomRadio from '@/components/common/CustomRadioBorder';
import CustomTextArea from "CustomTextArea";
import ActionButton from "ActionButton";

export default {
  name: "Communication",
  components: {
    SectionTitle,
    CustomRadio,
    CustomTextArea,
    ActionButton
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({
        comment: null,
        hasSignificantDisability: null,
        travelUnsupervisedRequired: null,
      }),
    },
    validable: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      significantDisabilityOptions: [
        { label: "SI", value: true, check: false },
        { label: "NO", value: false, check: false },
      ],
      travelUnsupervisedOptions: [
        { label: "SI", value: true, check: false },
        { label: "NO", value: false, check: false },
      ],
      model: {
        comment: null,
        hasSignificantDisability: null,
        travelUnsupervisedRequired: null,
      },
    };
  },
  methods: {
    updateSignificantDisability(option) {
      this.model.hasSignificantDisability = option.value;
    },
    updateTravelUnsupervisedSelection(option) {
      this.model.travelUnsupervisedRequired = option.value;
    },
    markSelectionAsChecked(data) {
      let significantDisabilityOption = this.significantDisabilityOptions.find(x => x.value == data.hasSignificantDisability);
      if (significantDisabilityOption) significantDisabilityOption.check = true;

      let travelUnsupervisedOptionSelected = this.travelUnsupervisedOptions.find(x => x.value == data.travelUnsupervisedRequired);
      if (travelUnsupervisedOptionSelected) travelUnsupervisedOptionSelected.check = true;
    },
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(newValue) {
        Object.assign(this.model, newValue);
        this.markSelectionAsChecked(newValue);
      }
    },
    model: {
      deep: true,
      handler(newValue) {
        this.$emit('input', newValue);
      }
    },
  }
};
</script>


<style scoped>
.item-pane {
  justify-content: space-between;
  min-width: 50%;
  margin-top: 10px;
  display: flex;
  border-bottom: solid 1px #e2e2e2;
}

.question-line p {
  padding-bottom: 0px;
}

.question-line p >>> p {
  margin-bottom: 0px !important;
}

.radio-button-container >>> .cr-icon {
  opacity: 1 !important;
}
</style>

